export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "olathe",
    name: "Olathe",
    state: "KS",
    region: "Johnson County",
    isPrimary: true,
    lat: 38.8814,
    lng: -94.8191,
    description:
      "B&S Services KC LLC is proudly headquartered in Olathe, KS. We serve homes and businesses across Johnson County with mowing, landscape maintenance, bed detailing, and turf applications — available 24/7.",
    highlights: [
      "Headquartered in Olathe, KS",
      "Trusted by homeowners & businesses",
      "Available 24/7 for your schedule",
      "Fully insured lawn & landscape crews",
    ],
    content: [
      "Olathe is our home base. We know Johnson County lawns — from the neighborhoods off Santa Fe and Kansas City Road to the newer subdivisions and commercial properties around the city. We bring our own equipment and a plan tailored to your yard.",
      "Residential clients in Olathe count on us for weekly mowing, seasonal mulching and trimming, and recurring bed detailing that keeps their landscaping sharp. Commercial clients trust us to keep their grounds looking professional year-round.",
      "Call (913) 420-3053 for a free, no-pressure estimate in Olathe today.",
    ],
    cities: [
      { name: "Cedar Creek", lat: 38.86, lng: -94.86 },
      { name: "Lenexa", lat: 38.9536, lng: -94.7336 },
      { name: "Gardner", lat: 38.8108, lng: -94.9272 },
      { name: "Shawnee", lat: 39.0417, lng: -94.7203 },
    ],
  },
  {
    slug: "overland-park",
    name: "Overland Park",
    state: "KS",
    region: "Johnson County",
    isPrimary: false,
    lat: 38.9822,
    lng: -94.6708,
    description:
      "Professional lawn care and landscaping in Overland Park, KS. Mowing, landscape maintenance, bed detailing, and turf applications with reliable recurring scheduling.",
    highlights: [
      "Weekly & bi-weekly mowing",
      "Residential & commercial lawn care",
      "Free written estimates",
      "10% returning-customer discount",
    ],
    content: [
      "Overland Park homeowners and businesses count on B&S Services KC for healthy, well-kept lawns and landscaping. Our crews arrive on time with their own equipment and a clear plan for every visit.",
      "We handle single-family yards, townhomes, HOAs, and commercial grounds throughout Overland Park. Recurring customers save 10% on their next service.",
      "Call (913) 420-3053 to book a free lawn care estimate in Overland Park.",
    ],
    cities: [
      { name: "Leawood", lat: 38.9667, lng: -94.6169 },
      { name: "Prairie Village", lat: 38.9917, lng: -94.6336 },
      { name: "Corporate Woods", lat: 38.94, lng: -94.66 },
    ],
  },
  {
    slug: "leawood",
    name: "Leawood",
    state: "KS",
    region: "Johnson County",
    isPrimary: false,
    lat: 38.9667,
    lng: -94.6169,
    description:
      "Leawood's trusted lawn and landscape company. Mowing, mulching, trimming, bed detailing, and turf applications — fully insured and detail-focused.",
    highlights: [
      "Premium mowing & edging",
      "Landscape maintenance & mulching",
      "Recurring bed detailing",
      "Insured, professional crews",
    ],
    content: [
      "Leawood is one of our most-requested areas. We care for manicured residential lawns, estate landscaping, and commercial grounds with the detail this community expects.",
      "Recurring customers in Leawood love how dependable we are — the same crew when possible, the same standard every visit, with a 10% loyalty discount built in.",
      "Reach us at (913) 420-3053 or request your free estimate online.",
    ],
    cities: [
      { name: "Hallbrook", lat: 38.94, lng: -94.63 },
      { name: "Overland Park", lat: 38.9822, lng: -94.6708 },
      { name: "Prairie Village", lat: 38.9917, lng: -94.6336 },
    ],
  },
  {
    slug: "shawnee",
    name: "Shawnee",
    state: "KS",
    region: "Johnson County",
    isPrimary: false,
    lat: 39.0417,
    lng: -94.7203,
    description:
      "Shawnee, KS lawn care and landscaping. We mow, mulch, trim, detail beds, and apply turf treatments with friendly, reliable service.",
    highlights: [
      "Weekly, bi-weekly & monthly service",
      "Mulching, trimming & planting",
      "Fully insured crews",
      "Free written estimates",
    ],
    content: [
      "Shawnee homes and businesses trust B&S Services KC for honest, detail-driven lawn care. We've cared for everything from newer subdivisions to established properties across the city.",
      "Our crews bring their own equipment and a clear checklist for every visit. Recurring maintenance keeps your yard looking its best all season.",
      "Book your free Shawnee estimate today by calling (913) 420-3053.",
    ],
    cities: [
      { name: "Shawnee Mission", lat: 39.02, lng: -94.68 },
      { name: "Lenexa", lat: 38.9536, lng: -94.7336 },
      { name: "Merriam", lat: 39.0236, lng: -94.6933 },
    ],
  },
  {
    slug: "lenexa",
    name: "Lenexa",
    state: "KS",
    region: "Johnson County",
    isPrimary: false,
    lat: 38.9536,
    lng: -94.7336,
    description:
      "Lenexa, KS professional lawn care. Mowing, landscape maintenance, bed detailing, and turf applications for homes and businesses.",
    highlights: [
      "Mowing, edging & blowing",
      "Landscape maintenance & mulching",
      "Turf fertilizer & weed control",
      "10% recurring customer discount",
    ],
    content: [
      "Lenexa is a regular stop on our service map. We care for residential lawns, HOA common areas, and commercial grounds with consistent, professional results.",
      "Whether you need weekly mowing or a full-season maintenance and turf program, our team delivers dependable quality.",
      "Call (913) 420-3053 for your free Lenexa, KS estimate.",
    ],
    cities: [
      { name: "Old Town Lenexa", lat: 38.97, lng: -94.73 },
      { name: "Olathe", lat: 38.8814, lng: -94.8191 },
      { name: "Shawnee", lat: 39.0417, lng: -94.7203 },
    ],
  },
  {
    slug: "prairie-village",
    name: "Prairie Village",
    state: "KS",
    region: "Johnson County",
    isPrimary: false,
    lat: 38.9917,
    lng: -94.6336,
    description:
      "Prairie Village, KS lawn and landscape care. Mowing, mulching, trimming, bed detailing, and turf applications with a detail-focused crew.",
    highlights: [
      "Mowing & precision edging",
      "Mulching, trimming & planting",
      "Recurring bed detailing",
      "Free written estimates",
    ],
    content: [
      "Prairie Village's tree-lined streets and classic homes deserve landscaping that looks its best — and that's exactly what we deliver. We mow, mulch, trim, and detail beds with care.",
      "Recurring customers in Prairie Village enjoy priority scheduling and a 10% loyalty discount on their next service.",
      "Book your Prairie Village lawn care at (913) 420-3053.",
    ],
    cities: [
      { name: "Mission Hills", lat: 39.01, lng: -94.62 },
      { name: "Leawood", lat: 38.9667, lng: -94.6169 },
      { name: "Overland Park", lat: 38.9822, lng: -94.6708 },
    ],
  },
  {
    slug: "topeka",
    name: "Topeka",
    state: "KS",
    region: "Shawnee County",
    isPrimary: false,
    lat: 39.0558,
    lng: -95.689,
    description:
      "Professional lawn care and landscaping in Topeka, KS. B&S Services KC LLC brings mowing, landscape maintenance, bed detailing, and turf applications to homes and businesses in the Topeka area.",
    highlights: [
      "Weekly & bi-weekly mowing",
      "Landscape maintenance & mulching",
      "Bed detailing & weed control",
      "Free written estimates",
    ],
    content: [
      "Topeka homeowners and businesses can count on B&S Services KC for dependable lawn care and landscaping. Our crews arrive with their own equipment and a clear plan for every visit.",
      "We handle residential yards, commercial grounds, and HOA properties throughout the Topeka area. From weekly mowing to seasonal mulching and turf applications, we keep your property looking its best.",
      "Call (913) 420-3053 to book a free lawn care estimate in Topeka.",
    ],
    cities: [
      { name: "Silver Lake", lat: 39.1036, lng: -95.8594 },
      { name: "Rossville", lat: 39.1361, lng: -95.9516 },
      { name: "Auburn", lat: 38.9067, lng: -95.8164 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
